import { RegistrationStep, StepName } from '../model';

export const stepToTitle = {
  [StepName.ClientType]: 'Я ищу',
} as const;

export const getStepTitle = (step: RegistrationStep): string | undefined => {
  return step.title || stepToTitle[step.name];
};
